import React, { useEffect } from "react";
import ShiftSelector from "../../../components/ShiftSelector";
import { useHost } from "../../../hooks/userInfoService";

export default function ShiftPage() {
  const { getCheckIn , checkInHost, saveShiftConfig} = useHost();

  useEffect(() => {
    getCheckIn();
  },[])

  const handleUpdate = (updatedShifts) => {
    saveShiftConfig(updatedShifts);
  };

  return (
    <div >
      <ShiftSelector
        initialShifts={checkInHost?.shiftConfig?.shifts || {}}
        onUpdate={handleUpdate}
      />
    </div>
  );
}
